/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Accentcolor1Inputs */

const en__field_accentcolor1 = /** @type {(inputs: _Field_Accentcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`accent Color`)
};

const de__field_accentcolor1 = /** @type {(inputs: _Field_Accentcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`accent Farbe`)
};

/**
* | output |
* | --- |
* | "accent Color" |
*
* @param {_Field_Accentcolor1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_accentcolor1 = /** @type {((inputs?: _Field_Accentcolor1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Accentcolor1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_accentcolor1(inputs)
	return de__field_accentcolor1(inputs)
});
export { _field_accentcolor1 as "_field_accentColor" }